import { Component } from '@angular/core';
import { RiskConceptsComponent } from '../risk-concepts/risk-concepts.component';
@Component({selector:'app-risk-board',standalone:true,imports:[RiskConceptsComponent],template:'<app-risk-concepts [page]="1"></app-risk-concepts>'})
export class RiskBoardComponent {}
